import { render, staticRenderFns } from "./pigaiDetail.vue?vue&type=template&id=78b9cf30&scoped=true"
import script from "./pigaiDetail.vue?vue&type=script&lang=js"
export * from "./pigaiDetail.vue?vue&type=script&lang=js"
import style0 from "./pigaiDetail.vue?vue&type=style&index=0&id=78b9cf30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b9cf30",
  null
  
)

export default component.exports